import React, { useEffect, useState } from 'react';
import CampusDriveAdvertiseBanner from '../../Component/CampusDrive/upcomingCampusDrive';
import RegisteredCampusDriveList from '../../Component/CampusDrive/driveList';
import {
    registeredCampusDrive,
    registerForCampusDrive
} from '../../action/campusDrive';
import Modal from '../../Component/Common/Modal';
import ConfirmDriveRegistration from '../../Component/CampusDrive/driveRegistration';
import { toast } from 'react-toastify';

const Dashboard = () => {

    const [drives, setDrives] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [selectedDrive, setSelectedDrive] = useState(null);

    /* =========================
       FETCH REGISTERED DRIVES
    ========================== */
    const fetchDrives = (nextPage = 1) => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);

        registeredCampusDrive(nextPage, limit)
            .then(res => {
                if (res.status) {
                    const list = res.result.list || [];
                    const count = res.result.count || 0;

                    setDrives(prev =>
                        nextPage === 1 ? list : [...prev, ...list]
                    );

                    setPage(nextPage);

                    if (list.length === 0 || (nextPage * limit) >= count) {
                        setHasMore(false);
                    }
                }
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        fetchDrives(1);
    }, []);

    /* =========================
       REGISTER FLOW
    ========================== */
    const handleRegisterClick = (drive) => {
        setSelectedDrive(drive);
        setShowModal(true);
    };

    const handleConfirmRegistration = () => {
        registerForCampusDrive({ DRIVE_ID: selectedDrive.ID })
            .then(res => {
                if (res.status) {
                    toast.success('Successfully registered for campus drive');

                    setShowModal(false);
                    setSelectedDrive(null);

                    // Refresh registered list
                    setPage(1);
                    setHasMore(true);
                    fetchDrives(1);
                } else {
                    toast.error(res.error);
                }
            });
    };

    return (
        <div className="container-fluid">

            {/* UPCOMING DRIVE BANNER */}
            <CampusDriveAdvertiseBanner
                onRegister={handleRegisterClick}
            />

            {/* REGISTERED DRIVES */}
            <RegisteredCampusDriveList
                drives={drives}
                fetchDrives={fetchDrives}
                hasMore={hasMore}
                isLoading={isLoading}
                page={page}
            />

            {/* CONFIRM REGISTRATION MODAL */}
            <Modal
                isOpen={showModal}
                header="Confirm Campus Drive Registration"
                onClose={() => setShowModal(false)}
            >
                {selectedDrive && (
                    <ConfirmDriveRegistration
                        drive={selectedDrive}
                        onConfirm={handleConfirmRegistration}
                        onClose={() => setShowModal(false)}
                    />
                )}
            </Modal>

        </div>  
    );
};

export default Dashboard;
